
  import axios from 'axios'

  export default {
    props: {
      initialTerm: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        inputValue: '',
        q: '',
        resultsCount: 0,
        pageNumber: 1,
        pageCount: 1,
        results: [],
        status: 'loading'
      }
    },
    methods: {
      async search() {
        if (this.inputValue) {
          this.status = 'loading'
          this.q = this.inputValue
          const response = await axios.get(`/webapi/searchapi/query?q=${this.q}`)
          if (response.status === 200) {
            this.pageNumber = response.data.pageNumber
            this.pageCount = response.data.pageCount
            this.results = response.data.results
            this.resultsCount = response.data.resultsCount
          } else {
            this.status = 'error'
          }
        }
        this.status = 'ready'
      },
      async nextPage() {
        this.status = 'loading'
        const response = await axios.get(`/webapi/searchapi/query?q=${this.q}&page=${this.pageNumber + 1}`)
        if (response.status === 200) {
          this.pageNumber = response.data.pageNumber
          this.pageCount = response.data.pageCount
          this.results.push(...response.data.results)
          this.resultsCount = response.data.resultsCount
          this.status = 'ready'
        } else {
          this.status = 'error'
        }
      }
    },
    mounted() {
      this.inputValue = this.initialTerm
      this.search()
    }
  }
